import './GameId.styles.scss';

import { Chip } from 'primereact/chip';
import { Tooltip } from 'primereact/tooltip';
import React, { FC, useMemo, useState } from 'react';

import notificationStore from '../../../../store/NotificationStore';
import { copyToClipboard } from '../../../../utils/keyboard.utils';
import { GameIdProps } from './GameId.types';

const GameId: FC<GameIdProps> = ({ gameId }) => {
  const [expanded, setExpanded] = useState(true);

  const onLabelClick = (): void => setExpanded(prev => !prev);

  const onGameIdClick = (): Promise<void> =>
    copyToClipboard(gameId).then(() =>
      notificationStore.showNotification({
        severity: 'success',
        summary: 'Success',
        detail: 'Game ID successfully copied',
      }),
    );

  const template = useMemo(
    () => (
      <>
        <Tooltip
          className="game-id-tooltip"
          target={`#game-id-label-${gameId}`}
          position="bottom"
          mouseTrackLeft={40}
          mouseTrack
          content={expanded ? 'Minimize' : 'Expand'}
        />
        <p
          id={`game-id-label-${gameId}`}
          className="d-inline m-0 me-2 cursor-pointer"
          onClick={onLabelClick}
        >
          Game ID:
        </p>
        <Tooltip
          className="game-id-tooltip"
          target={`#game-id-value-${gameId}`}
          position="bottom"
          mouseTrackLeft={25}
          mouseTrack
          content="Copy"
        />
        <b id={`game-id-value-${gameId}`} onClick={onGameIdClick}>
          {' ' + (expanded ? gameId : gameId.slice(0, 12) + '..')}
        </b>
      </>
    ),
    [gameId, expanded],
  );

  return (
    <div className="GameId-Component" data-ignore-outside-click={true}>
      <Chip className="chip" template={template} />
    </div>
  );
};

export default GameId;
